export class InfoPanelContext {
    public constructor(
        public connectionWizardHandler: (settingType: string) => void
    ) { }
}
